import { all, fork } from 'redux-saga/effects';
import { coreRootSaga } from './core/sagas';
import { currentUserProfileRootSaga } from './current-user-profile';
import { documentRootSaga } from './documents/saga';
import { homeRootSaga } from './home/sagas';
import { membersRootSaga } from './members/saga/index';
import { personalTasksRootSaga } from './personal-tasks/sagas';
import { projectRootSaga } from './projects';
import { spaceTabsRootSaga } from './space-tabs/sagas';
import { spacesRootSaga } from './spaces/sagas';
import { taskRootSaga } from './tasks';
import { templatesRootSaga } from './templates';
export const rootSaga = function*() {
    yield all([
        fork(projectRootSaga),
        fork(taskRootSaga),
        fork(documentRootSaga),
        fork(membersRootSaga),
        fork(currentUserProfileRootSaga),
        fork(personalTasksRootSaga),
        fork(spacesRootSaga),
        fork(spaceTabsRootSaga),
        fork(templatesRootSaga),
        fork(homeRootSaga),
        fork(coreRootSaga)
    ]);
};
